<template>
    <div v-wechat-title="title">
        <crud-facecade
            :url="url"
            :columns="columnList"
            :buttons="[]"
            :tableHeight="tableHeight"
            dialogWidth="60%"
            :addButton="{ permission: 'package:create' }"
            :updateButton="{ permission: 'package:update' }"
        >
        </crud-facecade>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
    name: `DicPackage`,
    props: {

    },
    data() {
        return {
            title: `器械包维护`,
            url: { baseURL: `/api/AcisSystem/Package`,
                getOne: (row) => {
                    return new Promise((resolve, reject) => {
                        let req = this.myaxios.get(`/api/AcisSystem/Package/Get/${row.id}`)
                        req.then(data => {
                            let r = {
                                id: data.id,
                                code: data.code,
                                name: data.name,
                                valid_days: data.valid_days,
                                description: data.description,
                                is_deleted: data.is_deleted,
                                is_external: data.is_external,
                                instruments: data.instruments && data.instruments.map((di, index) => {
                                    return {
                                        id: di.id,
                                        quantity: di.quantity,
                                        display_order: index
                                    }
                                })
                            }
                            resolve(r)
                        }).catch(e => reject(e))
                    })
                },
                post: (row) => {
                    return new Promise((resolve, reject) => {
                    // let its = _.groupBy( _.filter(row.instruments,ins=> {return ins.id>0}),'id')
                    // row.instruments = _.reduce(its, function(result, value, key) {
                    //   let v = value[0]
                    //   v.quantity = _.sumBy(value,d=>{return d.quantity})
                    //   result.push(v)
                    //   return result
                    // }, [])
                        row.instruments = _.orderBy(row.instruments, `display_order`)
                        let req = this.myaxios.post(`/api/AcisSystem/Package/Post`, row)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                },
                put: (row) => {
                    return new Promise((resolve, reject) => {
                    // let its = _.groupBy( _.filter(row.instruments,ins=> {return ins.id>0}),'id')
                    // row.instruments = _.reduce(its, function(result, value, key) {
                    //   let v = value[0]
                    //   v.quantity = _.sumBy(value,d=>{return d.quantity})
                    //   result.push(v)
                    //   return result
                    // }, [])
                        row.instruments = _.orderBy(row.instruments, `display_order`)
                        let req = this.myaxios.put(`/api/AcisSystem/Package/Put`, row)
                        req.then(data => {
                            resolve(data)
                        }).catch(e => reject(e))
                    })
                } },
            instruments: []
        }
    },
    created() {
        this.loadInstruments()
    },
    computed: {
        ...mapGetters([`screenHeight`]),
        tableHeight() {
            return this.screenHeight && (this.screenHeight - 190) || 0
        },
        columnList() {
            return [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                // width: "180",
                isListable: false,
                isExpand: false,
                isEditable: false,
                isCreatable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `code`,
                label: `编码`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `name`,
                label: `名称`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                searchable: true,
                colspan: 12,
                validate: [{ required: true, message: `必填项目`, trigger: `blur` }]
            }, {
                type: `string`,
                prop: `abbr`,
                label: `缩写`,
                width: `180`
            }, {
                type: `select`,
                prop: `is_external`,
                label: `外来`,
                options: `enum_bool`,
                colspan: 12,
                isListable: true,
                isEditable: true,
                isCreatable: true,
                default: false,
                width: `120`
            }, {
                type: `number`,
                prop: `valid_days`,
                label: `有效期(天)`,
                width: `180`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                colspan: 12,
                isCreatable: true,
                default: 1
            }, {
                type: `string`,
                prop: `description`,
                label: `描述`,
                isListable: true,
                isExpand: false,
                isEditable: true,
                isCreatable: true,
                colspan: 24,
                searchable: true
            }, {
                type: `string`,
                prop: `modifier`,
                label: `修改人`,
                width: `180`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `modify_date`,
                label: `修改时间`,
                width: `180`,
                isListable: true,
                sortable: `desc`
            }, {
                type: `rbool`,
                prop: `is_deleted`,
                label: `状态`,
                width: `70`,
                isListable: true,
                readonly: false,
                options: `is_enabled`,
                default: false
            }, {
                type: `table`,
                prop: `instruments`,
                label: `器械`,
                isEditable: true,
                isCreatable: true,
                options: [{
                    type: `number`,
                    prop: `display_order`,
                    label: `排序`,
                    width: `180`,
                    isListable: true,
                    readonly: false,
                    sortable: `asc`,
                    isDisplayOrder: true
                }, {
                    type: `select`,
                    prop: `id`,
                    label: `名称`,
                    width: `400`,
                    isListable: true,
                    isKey: true,
                    readonly: false,
                    options: (that, { row }) => {
                        return _.filter(this.instruments, d => {
                            return d.is_deleted == false || d.value == row.id
                        })
                    }
                }, {
                    type: `number`,
                    prop: `quantity`,
                    label: `数量`,
                    isListable: true,
                    readonly: false,
                    default: 1
                }],
                colspan: 24,
                default: [],
                config: {
                    height: this.screenHeight - 400
                }
            }]
        }
    },
    methods: {
        loadInstruments() {
            let that = this
            let req = that.myaxios.get(`/api/AcisSystem/Instrument/Get`)
            req.then(data => {
                //  _.filter(data,{is_deleted:false})
                that.instruments = data && data.map(d => {
                    return {
                        value: d.id,
                        label: d.name,
                        jianpin: d.abbr,
                        is_deleted: d.is_deleted
                    }
                })
            }).catch(e => { that.instruments = [] })
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Dictionary/Instrument/Package.vue